// This program has been developed by students from the bachelor Computer Science at
// Utrecht University within the Software Project course.
// Copyright (c) Utrecht University (Department of Information and Computing Sciences)

import axios from "axios";
import { store } from "@/store";
import * as authAPI from "./AuthenticationAPI";
import * as bundleAPI from "./BundleAPI";
import * as classAPI from "./ClassroomAPI";
import * as levelAPI from "./LevelAPI";
import * as progressAPI from "./ProgressAPI";
import * as userAPI from "./UserAPI";
import * as worldAPI from "./WorldAPI";

// Axios default parameters
axios.defaults.baseURL = process.env.VUE_APP_SERVER_BASE;

// Request interceptor to add an authentication token
axios.interceptors.request.use(function (req) {
  if (!store.state.authTokens) return req;
  const token: string | undefined = store.state.authTokens.authToken;
  if (token) {
    if (req.headers) {
      req.headers["Authorization"] = `Bearer ${token}`;
      if (!req.headers["Content-Type"])
        req.headers["Content-Type"] = "application/json";
    }
  }
  return req;
});

export {
  authAPI,
  bundleAPI,
  classAPI,
  levelAPI,
  progressAPI,
  userAPI,
  worldAPI,
};
